import {Navigate} from 'react-router-dom';
import * as React from 'react';
import {useRouter} from '../hooks/use-router';
import {useAuth} from '../hooks/use-auth';

/**
 * <ProtectedBusinessSpecificRoute> checks two things
 * 1. authentication: if not, redirect to unauthorized
 * 2. business selected: if not, redirect to business-selection
 *
 * In v6 this is used as a wrapper element, not a Route replacement.
 * Usage: <Route path="/forecast" element={<ProtectedBusinessSpecificRoute isAuthorized={true}><ViewForecast /></ProtectedBusinessSpecificRoute>} />
 */
export default function ProtectedBusinessSpecificRoute(props: {isAuthorized: boolean; children: React.ReactNode}) {
    const auth = useAuth();
    const router = useRouter();

    if (!props.isAuthorized) {
        return <Navigate to="/unauthorized" replace />;
    }

    if (!auth.authInformation?.current && router.pathname !== '/business-selection') {
        return <Navigate to="/business-selection" replace />;
    }

    return <>{props.children}</>;
}
